import { Box, Grid, Tab, Tabs } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { SectionServices } from '../Section/SectionServices';
import Swal from 'sweetalert2';

const SectionTabs = ({selectedSection, setSelectedSection, initialSectionId, pageType = 'section'}) => {
    const [selectedTab, setSelectedTab] = useState(0);
    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
        setSelectedSection(
            sectionList[newValue]
        );
    };

    const [sectionList, setSectionList] = useState([]);
    const fetchSectionList = async () => {
        try{
            const response = await SectionServices.fetchSectionList();
            if(response.success == '1'){
                const allSections = response.data.list || [];
                const sections = allSections.filter(section => (section.displayOptions?.pageType || 'section') === pageType);
                setSectionList(sections);
                const initialIndex = initialSectionId ? sections.findIndex(section => section.id === parseInt(initialSectionId)) : 0;
                const nextIndex = initialIndex >= 0 ? initialIndex : 0;
                setSelectedTab(nextIndex);
                setSelectedSection(sections[nextIndex] || null);
            }else if(response.success == '0'){
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: response.message || 'Failed to fetch sections',
                });
                setSectionList([]);
            }

        } catch(error){
            console.log("error", error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch section details',
            });
        }
    }
    useEffect(()=>{
        fetchSectionList();
    },[initialSectionId, pageType])
  return (
    <Box sx={{ marginTop: '.5%' }}>
        <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            orientation="vertical" // Set the orientation to 'vertical'
            variant="scrollable" // Use 'scrollable' variant for longer lists
            scrollButtons="auto"
            sx={{ backgroundColor: "#fff" }}
            align="left"
        >
            {sectionList?.map((section, index) => (
                <Tab key={index} label={section.title}
                    sx={{
                        borderBottom: '1px solid lightGray',
                        fontSize: '.8rem',
                        bgcolor:section?.isActive ? 'transparent' : '#ed6c02',
                        // color: section?.isActive ? '#fff' : 'text.primary',
                        // textTransform:'capitalize',
                    }}
                />
            ))}
        </Tabs>
    </Box>
  )
}

export default SectionTabs
